/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InputAdornment, Typography } from '@material-ui/core';
import propTypes from 'prop-types';

import { StyledTextField } from './styles';

export function CustomTextField({
  prefix,
  value,
  setValue,
  placeholder,
  ...props
}) {
  return (
    <StyledTextField
      variant="outlined"
      size="small"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder={placeholder}
      InputProps={{
        style: { fontSize: '14px' },
        startAdornment: prefix ? (
          <InputAdornment position="start">
            <Typography style={{ fontSize: '14px' }}>{prefix}</Typography>
          </InputAdornment>
        ) : null,
      }}
      {...props}
    />
  );
}

CustomTextField.propTypes = {
  prefix: propTypes.string,
  value: propTypes.string,
  setValue: propTypes.func,
};
